import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IGoalLabelProps {
  className?: string;
  id: string;
}

// Renders as an intermediate breadcrumb on child routes (e.g. converters); not visible on the detail page itself.
function GoalLabel({ className, id }: Readonly<IGoalLabelProps>): JSX.Element {
  const { Goals } = useStore();
  const goal = Goals.get(id);
  return (
    <div className={classNames({ [skeleton]: goal.isPending }, className)}>{goal.get('name')}</div>
  );
}

export default observer(GoalLabel);
